var _g, _path, _g2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecretPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2045_2465)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.16406,
    y: 8.82495,
    width: 65.9128,
    height: 60.7767,
    transform: "rotate(-0.922495 7.16406 8.82495)",
    fill: "#D2FF72"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9782 42.9413C38.9782 41.9775 39.2991 41.0469 39.9408 40.1496C40.5826 39.2522 41.596 38.2219 42.9808 37.0586C44.3657 35.8289 45.2946 34.8817 45.7675 34.217C46.2404 33.5523 46.4768 32.7713 46.4768 31.8739C46.4768 30.7107 46.0715 29.7468 45.2608 28.9824C44.484 28.218 43.5213 27.8358 42.3728 27.8358C40.076 27.8358 38.4377 29.2649 37.4582 32.1232L32.9995 30.2287C33.7088 27.9022 34.8911 26.1241 36.5462 24.8944C38.2351 23.6315 40.2448 23 42.5755 23C45.2102 23 47.4395 23.8143 49.2635 25.4428C51.0875 27.0381 51.9995 29.0489 51.9995 31.4751C51.9995 32.9042 51.6448 34.217 50.9355 35.4135C50.2262 36.5767 49.0777 37.8397 47.4902 39.2023C46.0377 40.4653 45.0751 41.3959 44.6022 41.9941C44.1293 42.5591 43.8928 43.1906 43.8928 43.8886C43.8928 44.2874 43.9604 44.7361 44.0955 45.2346L39.5355 45.2346C39.164 44.4037 38.9782 43.6393 38.9782 42.9413ZM39.1808 55.9032C38.4377 55.172 38.0662 54.2581 38.0662 53.1613C38.0662 52.0645 38.4377 51.1505 39.1808 50.4194C39.9577 49.6549 40.9035 49.2727 42.0182 49.2727C43.1328 49.2727 44.0617 49.6383 44.8048 50.3695C45.5817 51.1007 45.9702 52.0313 45.9702 53.1613C45.9702 54.2581 45.5817 55.172 44.8048 55.9032C44.0617 56.6344 43.1328 57 42.0182 57C40.9035 57 39.9577 56.6344 39.1808 55.9032Z",
    fill: "#42C7F1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2045_2465)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.2777,
    cy: 8.80313,
    r: 2.56803,
    transform: "rotate(6.51456 39.2777 8.80313)",
    fill: "#FFA800"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 39.2782,
    cy: 8.80316,
    r: 1.71202,
    transform: "rotate(6.51456 39.2782 8.80316)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2045_2465",
    x: 3.16406,
    y: 7.76379,
    width: 74.8828,
    height: 69.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2045_2465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2045_2465",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2045_2465",
    x: 33.7095,
    y: 4.23486,
    width: 11.1362,
    height: 11.1365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498333 0 0 0 0 0.291667 0 0 0 0 0.625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2045_2465"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2045_2465",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretPaper);
export default __webpack_public_path__ + "static/media/SecretPaper.534e5bb7c3518ca72f9f567d417d23c3.svg";
export { ForwardRef as ReactComponent };